var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldShow
    ? _c(
        "section",
        {
          staticClass: "limited-coupon",
          attrs: { "aria-labelledby": "limited-coupon-title" },
          on: {
            mouseenter: _vm.handleCarouselMouseEnter,
            mouseleave: _vm.handleCarouselMouseLeave,
            focusin: _vm.handleCarouselFocusIn,
            focusout: _vm.handleCarouselFocusOut,
          },
        },
        [
          _c("header", { staticClass: "limited-coupon__header" }, [
            _c("h2", { attrs: { id: "limited-coupon-title" } }, [
              _vm._v(_vm._s(_vm.$t("super_coupon_title"))),
            ]),
            _vm.formattedEndTime
              ? _c("p", [
                  _c("span", [_vm._v(_vm._s(_vm.$t("super_coupon_end_time")))]),
                  _c("time", [_vm._v(_vm._s(_vm.formattedEndTime))]),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "limited-coupon__slider",
              on: {
                "&touchstart": function ($event) {
                  return _vm.handleTouchStart.apply(null, arguments)
                },
                "&touchend": function ($event) {
                  return _vm.handleTouchEnd.apply(null, arguments)
                },
                "&touchcancel": function ($event) {
                  return _vm.handleTouchCancel.apply(null, arguments)
                },
              },
            },
            [
              _vm.hasMultipleActivities
                ? _c(
                    "button",
                    {
                      staticClass:
                        "limited-coupon__nav limited-coupon__nav--previous",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t("super_coupon_previous_activity"),
                      },
                      on: { click: _vm.showPreviousActivity },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-chevron-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  )
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: _vm.carouselTransitionName, mode: "out-in" } },
                [
                  _c(
                    "article",
                    {
                      key: _vm.activityKey,
                      staticClass: "limited-coupon__product",
                      class: {
                        "limited-coupon__product--no-value": !_vm.realValueText,
                      },
                    },
                    [
                      _c("span", { staticClass: "limited-coupon__badge" }, [
                        _vm._v(_vm._s(_vm.$t("super_coupon_recommended"))),
                      ]),
                      _c(
                        "button",
                        {
                          ref: "detailsTrigger",
                          staticClass: "limited-coupon__info",
                          attrs: {
                            type: "button",
                            "aria-label": _vm.$t("super_coupon_view_details"),
                          },
                          on: { click: _vm.openDetails },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-info",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "limited-coupon__top" }, [
                        _c("div", { staticClass: "limited-coupon__summary" }, [
                          _c(
                            "div",
                            { staticClass: "limited-coupon__image-wrap" },
                            [
                              _vm.activity.icon
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.activity.icon,
                                      alt: _vm.packageTitle,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _c("div", { staticClass: "limited-coupon__copy" }, [
                            _c("h3", [_vm._v(_vm._s(_vm.packageTitle))]),
                            _c("p", [_vm._v(_vm._s(_vm.promotionalCopyText))]),
                            _c("strong", [_vm._v(_vm._s(_vm.currentPrice))]),
                          ]),
                        ]),
                        _vm.realValueText
                          ? _c(
                              "div",
                              { staticClass: "limited-coupon__value" },
                              [
                                _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("super_coupon_value_label"))
                                    ),
                                  ]),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.realValueText)),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "limited-coupon__bottom" }, [
                        _c(
                          "div",
                          { staticClass: "limited-coupon__benefit-copy" },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "limited-coupon__benefits",
                                attrs: {
                                  "aria-label": _vm.$t("super_coupon_contents"),
                                },
                              },
                              _vm._l(_vm.benefits, function (benefit, index) {
                                return _c(
                                  "li",
                                  {
                                    key: `${benefit.threshold}-${index}`,
                                    class: `limited-coupon__benefit--${benefit.state}`,
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "limited-coupon__threshold",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("super_coupon_threshold", {
                                              amount: benefit.threshold,
                                            })
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "strong",
                                      {
                                        staticClass: "limited-coupon__discount",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("super_coupon_discount", {
                                              amount: benefit.discount,
                                            })
                                          )
                                        ),
                                      ]
                                    ),
                                    benefit.state === "active"
                                      ? _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("super_coupon_remaining", {
                                                time: benefit.remainingTime,
                                              })
                                            )
                                          ),
                                        ])
                                      : benefit.statusText
                                      ? _c("small", [
                                          _vm._v(_vm._s(benefit.statusText)),
                                        ])
                                      : _c("small", [
                                          _vm._v(_vm._s(benefit.validity)),
                                        ]),
                                    benefit.statusText
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "limited-coupon__status-stamp",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(benefit.statusText) +
                                                "\n\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm.purchaseRuleText
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "limited-coupon__purchase-rule",
                                  },
                                  [_vm._v(_vm._s(_vm.purchaseRuleText))]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "limited-coupon__buy",
                            class: {
                              "limited-coupon__buy--purchased":
                                _vm.hasPurchased,
                            },
                            attrs: {
                              id: "superCouponBuyButton",
                              type: "button",
                              disabled: _vm.paymentOpening || _vm.hasPurchased,
                            },
                            on: { click: _vm.openPayment },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    _vm.hasPurchased
                                      ? "super_coupon_purchased"
                                      : "super_coupon_buy_now"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm.hasMultipleActivities
                ? _c(
                    "button",
                    {
                      staticClass:
                        "limited-coupon__nav limited-coupon__nav--next",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t("super_coupon_next_activity"),
                      },
                      on: { click: _vm.showNextActivity },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-chevron-right",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.hasMultipleActivities
            ? _c(
                "div",
                {
                  staticClass: "limited-coupon__pagination",
                  attrs: { "aria-label": _vm.$t("super_coupon_switcher") },
                },
                _vm._l(_vm.activities, function (item, index) {
                  return _c("button", {
                    key: `activity-dot-${item.activityId || index}`,
                    staticClass: "limited-coupon__dot",
                    class: {
                      "limited-coupon__dot--active":
                        index === _vm.currentActivityIndex,
                    },
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("super_coupon_switch_to", {
                        index: index + 1,
                      }),
                      "aria-current":
                        index === _vm.currentActivityIndex ? "true" : null,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectActivity(index)
                      },
                    },
                  })
                }),
                0
              )
            : _vm._e(),
          _vm.showDetails
            ? _c(
                "div",
                {
                  staticClass: "super-coupon-dialog__mask",
                  on: {
                    click: function ($event) {
                      if ($event.target !== $event.currentTarget) return null
                      return _vm.closeDetails.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      ref: "detailsPanel",
                      staticClass: "super-coupon-dialog",
                      attrs: {
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "super-coupon-dialog-title",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "super-coupon-dialog__header" },
                        [
                          _c(
                            "h3",
                            { attrs: { id: "super-coupon-dialog-title" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("super_coupon_details_title"))
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              ref: "detailsClose",
                              staticClass: "super-coupon-dialog__close",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.$t(
                                  "super_coupon_close_details"
                                ),
                              },
                              on: { click: _vm.closeDetails },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-close",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm.detailCoupons.length
                        ? _c(
                            "ul",
                            { staticClass: "super-coupon-dialog__list" },
                            _vm._l(_vm.detailCoupons, function (coupon) {
                              return _c(
                                "li",
                                {
                                  key: coupon.id,
                                  class: `super-coupon-dialog__item--${coupon.state}`,
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(coupon.threshold)),
                                  ]),
                                  _c("strong", [
                                    _vm._v(_vm._s(coupon.discount)),
                                  ]),
                                  coupon.stateText
                                    ? _c("small", [
                                        _vm._v(_vm._s(coupon.stateText)),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "p",
                            { staticClass: "super-coupon-dialog__empty" },
                            [_vm._v(_vm._s(_vm.$t("super_coupon_empty")))]
                          ),
                      _vm.usageInstructionsText
                        ? _c(
                            "div",
                            {
                              staticClass: "super-coupon-dialog__instructions",
                            },
                            [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(_vm.$t("super_coupon_instructions"))
                                ),
                              ]),
                              _c("p", [
                                _vm._v(_vm._s(_vm.usageInstructionsText)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "super-coupon-dialog__footer" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "super-coupon-dialog__confirm",
                              attrs: { type: "button" },
                              on: { click: _vm.closeDetails },
                            },
                            [_vm._v(_vm._s(_vm.$t("super_coupon_confirm")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }